import { render, staticRenderFns } from "./msds-sheets-list.vue?vue&type=template&id=553c6d79&scoped=true&"
import script from "./msds-sheets-list.vue?vue&type=script&lang=js&"
export * from "./msds-sheets-list.vue?vue&type=script&lang=js&"
import style0 from "./msds-sheets-list.vue?vue&type=style&index=0&id=553c6d79&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553c6d79",
  null
  
)

export default component.exports